import React from 'react';
import { X } from 'lucide-react';
export function ProblemSection() {
  return <section className="bg-[#2c3e50] text-white py-16 md:py-24 px-4" data-id="element-146">
      <div className="max-w-4xl mx-auto" data-id="element-147">
        <div className="text-center mb-12" data-id="element-148">
          <h2 className="text-4xl md:text-5xl font-black mb-4 font-['Oswald'] uppercase text-white" data-id="element-149">
            El problema que nadie dice en voz alta
          </h2>
          <p className="text-xl text-gray-300" data-id="element-150">
            Si sos docente de primaria, esto seguramente te resulta familiar:
          </p>
        </div>

        <div className="grid md:grid-cols-1 gap-6 max-w-2xl mx-auto" data-id="element-151">
          <ul className="space-y-4" data-id="element-152">
            {['Pasás horas planificando cada semana', 'Tenés material, pero está desordenado', 'Buscás actividades en muchos lugares', 'Guardás recursos que después no encontrás', 'Terminás improvisando más de lo que querés'].map((item, index) => <li key={index} className="flex items-start gap-4 bg-[#34495e] p-4 rounded-lg transform hover:scale-[1.02] transition-transform" data-id="element-153">
                <div className="bg-red-500 rounded-full p-1 mt-1 flex-shrink-0" data-id="element-154">
                  <X className="w-5 h-5 text-white" data-id="element-155" />
                </div>
                <span className="text-lg font-medium" data-id="element-156">{item}</span>
              </li>)}
          </ul>
        </div>

        <div className="mt-12 text-center" data-id="element-157">
          <blockquote className="text-2xl md:text-3xl font-serif italic text-yellow-400 max-w-3xl mx-auto leading-relaxed" data-id="element-158">
            "Lo peor es esa sensación constante de: 'Podría dar mejores clases…
            si tuviera todo listo.'"
          </blockquote>
        </div>
      </div>
    </section>;
}